import { render } from "./LoginOtp.vue?vue&type=template&id=c521f87c&scoped=true"
import script from "./LoginOtp.vue?vue&type=script&lang=js"
export * from "./LoginOtp.vue?vue&type=script&lang=js"

import "./LoginOtp.vue?vue&type=style&index=0&id=c521f87c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c521f87c"]])

export default __exports__